import * as UnitDivide from "../unit-divide";
import { GallonsPerMinute, LiterPerSecond } from "./volume-flow";
import { TonCooling, KiloWatt } from "./power";
// Volume flow per cooling power
export var GallonsPerMinutePerTonCooling = UnitDivide.volumeFlowByPower("GallonsPerMinutePerTonCooling", GallonsPerMinute, TonCooling);
export var LiterPerSecondPerKiloWatt = UnitDivide.volumeFlowByPower("LiterPerSecondPerKiloWatt", LiterPerSecond, KiloWatt);
//# sourceMappingURL=volume-flow-per-power.js.map